import React, { useEffect, useRef, useState } from "react";
import { Field, useField } from "formik";
import { Row, Col } from "react-bootstrap";
import InputMask from "react-input-mask";
import "./General-Text-Input.css";

export const GeneralTextAreaField = ({ warning, label, mask, maxLength, ...props }) => {

    const [field, meta,helpers] = useField(props);
    const [validationCheck, setValidationCheck] = useState("");
    const [charsLeft, setCharsLeft] = useState(maxLength);
    const [isFocused, setIsFocused] = useState(false);
    const [charsColor, setCharsColor] = useState('black');

    // Calculate if the warning should be shown
    // 1. The field has a warning label
    // 2. The field has been touched (values were entered)
    // 3. field value is the same as the initial value
    const [showWarning, setShowWarning] = useState(warning  && (field.value === meta.initialValue))


    useEffect(() => {
        if (meta.touched && meta.error) {
            setValidationCheck("is-invalid");
        } else if (meta.touched && !meta.error) {
            setValidationCheck("is-valid");
        }
    }, [meta.touched, meta.error]);

    const adjustTextareaHeight = (event) => {
        event.target.style.height = "inherit";
        event.target.style.height = `${event.target.scrollHeight}px`;
    };
    const handleInputFocus = () => {
        setIsFocused(true);
    };

    const handleInputBlur = () => {
        setIsFocused(false);
    };
    useEffect(() => {
        const adjustTextareaHeight = (value) => {
            if (textareaRef.current) {
                textareaRef.current.style.height = "inherit";
                const scrollHeight = value
                    ? textareaRef.current.scrollHeight
                    : "inherit";
                textareaRef.current.style.height = `${scrollHeight}px`;
            }
        };

        // if field value changes, set touched to be true
        if(!meta.touched) {
            helpers.setTouched(true)
        }

        // Calculate if the warning should be shown
        // 1. The field has a warning label
        // 2. The field has been touched (values were entered)
        // 3. field value is the same as the initial value
        const shouldShowWarning = warning && !meta.touched && (field.value === meta.initialValue)

        // Only update the the showWarning state IFF they are different
        // Don't rerender if the state is not changed
        if(showWarning != shouldShowWarning) {
            setShowWarning(shouldShowWarning)
        }

        adjustTextareaHeight(field.value);
    }, [field.value]);

    useEffect(() => {
        if (maxLength) {

            let modifiedFieldValue = field.value;

            if (field.value && field.value.length > maxLength) {
                modifiedFieldValue = field.value.slice(0, maxLength);
            }

            const charCount = maxLength - modifiedFieldValue.length;
           const actualCount = maxLength - field.value.length;
            if (actualCount >= 0) {
                setCharsLeft(charCount);
                    setCharsColor('black');
            } else {
                setCharsLeft(actualCount);
                setCharsColor('red');
            }
        }
    }, [field.value, maxLength]);

    const textareaRef = useRef();

    return (
        <>
            <Col xs={12}>
                <Row>
                    <label
                        aria-hidden="true"
                        className=" label px-0 mx-0"
                        htmlFor={props.id || props.name}
                    >
                        {label}
                        &nbsp;
                        &nbsp;
                        {showWarning && (<b className="text-success">{warning}</b>)}
                    </label>
                </Row>
                <Row>
                    {mask ? (
                        <InputMask
                            {...field}
                            {...props}
                            mask={mask}
                            maskChar={null}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                        >
                            {(inputProps) => (
                                <Field
                                    {...field}
                                    {...props}
                                    {...inputProps}
                                    className={
                                        "form-control " + " " + validationCheck
                                    }
                                    onInput={adjustTextareaHeight}
                                    style={{ height: "auto", overflow: "auto" }}
                                />
                            )}
                        </InputMask>
                    ) : (
                        <>

                            {isFocused && maxLength &&
                                <div className={`character-count ${charsColor === 'red' ? 'character-count-red' : 'character-count-black'}`}>
                                    {charsLeft < 0
                                        ? `Too many characters entered.`
                                        : `${charsLeft} character${charsLeft !== 1 ? "s" : ""} remaining`
                                    }
                                </div>
                            }

                            <Field
                                {...field}
                                {...props}
                                className={
                                    "form-control " + " " + validationCheck
                                }
                                innerRef={textareaRef}
                                onInput={adjustTextareaHeight}
                                onFocus={handleInputFocus}
                                onBlur={handleInputBlur}
                                style={{
                                    height: "auto",
                                    overflow: "auto",
                                }}
                                aria-invalid={meta.touched && meta.error ? "true" : null}
                                aria-label={meta.touched && meta.error ? "Field error: " + meta.error : ""}
                            />
                            {/* {meta.touched && meta.error ? (
                                <p className="text-danger py-0 my-0 "
                                    id={field.name + "-error"}
                                >
                                    {meta.error}
                                </p>
                            ) : null} */}
                        </>
                    )}
                </Row>
            </Col>
            {meta.touched && meta.error  ? (
                <div className="text-danger py-0 my-0" aria-hidden="true" id={field.name + "-error"}>{meta.error}</div>
            ) : null}
        </>
    );
};
